import SeriesSection from '@/sections/izzi/series/series-section';

export default function SeriesPage() {
  return <SeriesSection />;
}
